import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { PageLayout } from '@/components/pagelay';
import { getHead, getServerSideProps } from '@/utils/useHead';
import useRequest from '@/utils/useRequest';
import styles from './index.module.scss';
import cName from "classnames";
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';
import useObserver from '@/utils/useObserver';
import { cloneDeep } from 'lodash';

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';

import * as echarts from 'echarts';

interface IProps {

}
export { getServerSideProps }

export default ({ navDetail }: any) => {
  const router = useRouter()
  const request = useRequest()

  const t = useTranslations();

  const tabList = useMemo(() => {
    return [
      {
        id: 1,
        title: t('overseas.tab1'),
        list: [
          {
            id: 1,
            title: t('overseas.item1.title', { th: '<sup>th</sup>' }),
            text: t('overseas.item1.text', { th: '<sup>th</sup>' }),
            time: t('overseas.item1.time'),
            address: t('overseas.item1.address'),
            cover: "/image/overseas/image1.png",
            link: "https://www.powtex.com/tokyo/",
          },
          {
            id: 2,
            title: t('overseas.item2.title'),
            text: t('overseas.item2.text'),
            time: t('overseas.item2.time'),
            address: t('overseas.item2.address'),
            cover: "/image/overseas/image2.png",
            link: "https://www.apowdertech.com/",
          },
          {
            id: 3,
            title: t('overseas.item3.title'),
            text: t('overseas.item3.text'),
            time: t('overseas.item3.time'),
            address: t('overseas.item3.address'),
            cover: "/image/overseas/image3.png",
            link: "https://unitedchemicalshow.com/en/for-exhibitors/booking-of-participation ",
          },
          {
            id: 4,
            title: t('overseas.item4.title'),
            text: t('overseas.item4.text'),
            time: t('overseas.item4.time'),
            address: t('overseas.item4.address'),
            cover: "/image/overseas/image4.png",
            link: "https://chemexpo-vietnam.com/",
          },
        ],
      },
      {
        id: 2,
        title: t('overseas.tab2'),
        list: [
          {
            id: 5,
            title: t('overseas.item5.title'),
            text: t('overseas.item5.text'),
            time: t('overseas.item5.time'),
            address: t('overseas.item5.address'),
            cover: "/image/overseas/image5.png",
            link: "https://www.powtech.de/en",
          },
          {
            id: 6,
            title: t('overseas.item6.title'),
            text: t('overseas.item6.text'),
            time: t('overseas.item6.time'),
            address: t('overseas.item6.address'),
            cover: "/image/overseas/image6.png",
            link: "https://home.analiticanet.com.br/",
          },
          {
            id: 7,
            title: t('overseas.item7.title'),
            text: t('overseas.item7.text'),
            time: t('overseas.item7.time'),
            address: t('overseas.item7.address'),
            cover: "/image/overseas/image7.png",
            link: "https://fcecosmetique.com.br/",
          },
          {
            id: 8,
            title: t('overseas.item8.title'),
            text: t('overseas.item8.text'),
            time: t('overseas.item8.time'),
            address: t('overseas.item8.address'),
            cover: "/image/overseas/image8.png",
            link: "https://fcepharma.com.br/",
          },
          {
            id: 9,
            title: t('overseas.item9.title'),
            text: t('overseas.item9.text'),
            time: t('overseas.item9.time'),
            address: t('overseas.item9.address'),
            cover: "/image/overseas/image9.png",
            link: "https://foodtech.gr/en/",
          },
          {
            id: 10,
            title: t('overseas.item10.title'),
            text: t('overseas.item10.text'),
            time: t('overseas.item10.time'),
            address: t('overseas.item10.address'),
            cover: "/image/overseas/image10.png",
            link: "https://www.partec.info/en",
          },
        ],
      },
    ]
  }, [router.locale])


  const [currentTab, setCurrentTab] = useState(1)

  return (
    <PageLayout title={(
      <>
        <h1 key={router.pathname} style={{ fontSize: '36px' }}>{
          router.locale === 'cn' ?
            'IPB 2027 第二十四届国际粉体、散料、流体加工展览会'
            :
            (
              <>
                24<sup>rd</sup> International Processing Trade Fair for Powder, Bulk Solids and Fluids
              </>
            )
        }</h1>
        <p style={{ fontSize: '24px', fontWeight: 'normal' }}>{t('common.time')}</p>
        <p style={{ fontSize: '24px', fontWeight: 'normal' }}>{t('common.site')}</p>
      </>
    )}>
      <div className={styles.container}>
        {getHead(navDetail)}
        <div className={styles.content}>
          <ul className={styles.tab}>
            {tabList.map((item) => (
              <li className={cName([styles.item, item.id === currentTab && styles.active])} key={item.id} onClick={() => setCurrentTab(item.id)}>{item.title}</li>
            ))}
          </ul>
          <ul className={styles.list}>
            {tabList.find((item) => item.id === currentTab)?.list.map((item) => (
              <li className={styles.item} key={item.id}>
                <div className={styles.inner}>
                  <div className={styles.left}>
                    <p className={styles.title} dangerouslySetInnerHTML={{ __html: item.title }}></p>
                    <div className={styles.sub}>
                      <p className={styles.time}>{item.time}</p>
                      <p className={styles.address}>{item.address}</p>
                    </div>
                    <p className={styles.text} dangerouslySetInnerHTML={{ __html: item.text }}></p>
                    {
                      item?.link && (
                        <a className={styles.link} href={item.link} target="_blank">
                          {t('overseas.check')}
                        </a>
                      )
                    }

                  </div>
                  <div className={styles.right}>
                    <img className={styles.cover} src={item.cover} alt={item.title} />
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <style jsx global>
          {
            `
            `
          }
        </style>
      </div>
    </PageLayout >
  );
};


